// src/firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Your web app's Firebase configuration
// IMPORTANT: Replace with your actual Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyA7XBFdBfnjyCAGag-TpDDPxt9uQAgzBHA",
  authDomain: "keycode-f81f1.firebaseapp.com",
  projectId: "keycode-f81f1",
  storageBucket: "keycode-f81f1.firebasestorage.app",
  messagingSenderId: "170038316761",
  appId: "1:170038316761:web:a4deb2fec2465c3c8ab8c8",
  measurementId: "G-G1QBJHSLZG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };